export enum FrameType {
  MOBILE = "MOBILE",
  DESKTOP = "DESKTOP",
  WIDE = "WIDE",
}
